import {textDialog, TextDialog} from "./text/component/TextInputDialogComponent";
import {TextInputDialog} from "./text/TextInputDialog";

export default function(): string {
    return angular.module("tfApp.services.dialog", [])
                  .component(TextDialog, textDialog())
                  .service(TextInputDialog.id, TextInputDialog)
                  .name;
}
